import {
    INITIALIZE_PAY_DATA,
    INITIALIZE_PAY_DATA_SUCCESS,
    GET_INSTALLMENTS,
    GET_INSTALLMENTS_SUCCESS,
    INSTALLMENT_API_ERROR
} from "./actionTypes"


export const getInstallments = record => ({
    type: GET_INSTALLMENTS,
    payload: record
})
export const getInstallmentsSuccess = record => ({
    type: GET_INSTALLMENTS_SUCCESS,
    payload: record,
})

export const initializePayData = (record,value, name) => ({
    type: INITIALIZE_PAY_DATA,
    payload: {record, value, name }
})
export const initializePayDataSuccess = record => ({
    type: INITIALIZE_PAY_DATA_SUCCESS,
    payload: record,
})

export const installmentApiError = error => {
    return {
        type: INSTALLMENT_API_ERROR,
        payload: error,
    }
}
